export default {
  employeeCount: null,
};
